import { DemandsFilterBar } from "@/components/demands/DemandsFilterBar";
import { DemandsTable } from "@/components/demands/DemandsTable";
import { PageContainer } from "@/components/shared/PageContainer";
import { PageHeader } from "@/components/shared/PageHeader";
import { useDemandFilters } from "@/hooks/use-demand-filters";

export function DemandsPage() {
  const { state, setState, reset } = useDemandFilters();
  return (
    <PageContainer>
      <PageHeader
        eyebrow="Operations"
        title="Demands"
        description="How each NOS Demand is resourced — actuals and guidance by month."
        actions={<DemandsFilterBar state={state} setState={setState} reset={reset} />}
      />
      <DemandsTable filters={state} setFilters={setState} />
    </PageContainer>
  );
}
